import script from "./SobreNosotrosPrivado.vue?vue&type=script&setup=true&lang=js"
export * from "./SobreNosotrosPrivado.vue?vue&type=script&setup=true&lang=js"

import "./SobreNosotrosPrivado.vue?vue&type=style&index=0&id=0c499acc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c499acc"]])

export default __exports__